import React from "react";

// Reusable "kop surat" header matching company branding - uses uploaded logo
export default function KopSurat() {
  return (
    <div className="kop-surat" style={{ marginBottom: 10, marginTop: 0, WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}>
      <div style={{ background: "#F2C744", height: 22, marginBottom: 6, WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }} />
      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        <img
          src="/logo-fivehoster.png"
          alt="PT. Fivehoster"
          style={{ width: 74, height: 74, objectFit: "contain", flexShrink: 0 }}
        />
        <div style={{ flex: 1, fontFamily: "'Times New Roman', Times, serif", color: "#000" }}>
          <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: 0.3, lineHeight: 1.15 }}>
            PT. FIVEHOSTER KARYA BANGSA
          </div>
          <div style={{ fontSize: 11, fontStyle: "italic", marginTop: 2 }}>
            Jasa Penyedia Server, Pembuatan Software dan Website
          </div>
          <div style={{ fontSize: 10.5, marginTop: 4 }}>
            Head Office : Jl. Sawah Lunto RT.27 RW.07 Jeru Kec.Turen Kab.Malang
          </div>
          <div style={{ fontSize: 10.5 }}>
            Telp/Email : (031) 30004702 – support@fivehoster.co.id
          </div>
        </div>
      </div>
      <div style={{ borderBottom: "2.5px solid #000", marginTop: 6 }} />
    </div>
  );
}
